/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/naming-convention */
import { Injectable } from '@angular/core';
import { DataCollectorService } from 'app/core/services/data_collector_services/data_collector_service.service';
import { DispatchBoardService } from '../dispatch-board/dispatch-board.service';
import _ from 'lodash';
import { AnyComponent } from '@fullcalendar/core/preact';
import { AdvanceFilterService } from 'app/components/quick-filter/advance-filter/advance-filter.service';

@Injectable({
  providedIn: 'root'
})
export class DispatchFilterService {
  public get baseUrl(): string {
    return `${this.dataCollectorService.baseurl()}`;
  };

  get filterAPIurls(): any{
    return {
      jobCategoryUrl: `${this.baseUrl}/jobs/category?populate_statuses=true`,
      skillsUrl: `${this.baseUrl}/skills`,
      serviceTerritoryUrl: `${this.baseUrl}/territory`,
      routesUrl: `${this.baseUrl}/routes`,
      saveFilterUrl: `${this.baseUrl}/misc/quick_filters`,
      customerUrl: `${this.baseUrl}/customers`,
      organizationUrl: `${this.baseUrl}/organization`,
      propertyUrl: `${this.baseUrl}/property`,
      teamUrl: `${this.baseUrl}/teams/summary`,
      employeeUrl: `${this.baseUrl}/user/all`,
      tagUrl:`${this.baseUrl}/company_tags`
    };
  };
  dispatchCurrentTab: 'JOBS' | 'ROUTES' = 'JOBS';
  // eslint-disable-next-line max-len
  defaultFilterOptions = { 'filterOptions': { 'grid': [], 'grid_route': [], 'employee': [], 'scheduler': [], 'map': { 'filter.route_uid': [] } },
   'sortOptions': { 'grid': { 'sort': 'DESC', 'sort_by': 'due_date' }, 'employee': {}, 'scheduler': {}, 'map': {} },
   'filterUid': 'ALL', 'filterCount': { 'grid': 0, 'employee': 0, 'scheduler': 0, 'map': 0 } };
  skipFilterKeyCount: any[] = ['keyword'];
  constructor(
    private dataCollectorService: DataCollectorService,
    private advanceFilterService: AdvanceFilterService,
    private _dispatchBoardService: DispatchBoardService
    ) { }

  getGridRouteFilterValue(filterValue: any): any {
    const gridRouteFilterValue: any = {
      'filter.keyword': filterValue.routeName ?? '',
      'filter.is_optimized': filterValue.routeOptimized === 'ANY' ? '' : filterValue.routeOptimized,
      'from_date': '',
      'to_date': ''
    };
    if (filterValue?.routeDateFrom?.format) {
      gridRouteFilterValue['from_date'] = filterValue?.routeDateFrom?.format('YYYY-MM-DD');
    }
    if (filterValue?.routeDateTo?.format) {
      gridRouteFilterValue['to_date'] = filterValue?.routeDateTo?.format('YYYY-MM-DD');
    }
    return gridRouteFilterValue;
  }

  getSchedulerRouteFilterValue(filterValue: any): any {
    const schedulerRouteFilterValue: any = {
      'filter.route_name': filterValue.routeName ?? '',
      'filter.is_route_optimized': filterValue.routeOptimized === 'ANY' ? '' : filterValue.routeOptimized,
    };
    return schedulerRouteFilterValue;
  }

  getMapFilterValue(filterValue: any): any {
    const mapFilterValue: any = {
      'filter.route_uid': filterValue.route ?? ''
    };
    return mapFilterValue;
  }

  getDispatchFilterValues(filterValues: any, actualValues: any): any {
    const _dispatchCurrentTab = this.dispatchCurrentTab.toLocaleLowerCase();
    const jobFilterValue = this.advanceFilterService.dispatchBoardFilterValues[_dispatchCurrentTab]|| [];
    const gridSearchFilterRule = actualValues.filterOptions?.grid ? actualValues.filterOptions.grid.filter((filterRule: any) => filterRule?.key === 'keyword') : [];
    const employeeSearchFilterRule = actualValues.filterOptions?.employee ? actualValues.filterOptions.employee.filter((filterRule: any) => filterRule?.key === 'keyword') : [];
    const schedulerSearchFilterRule = actualValues.filterOptions?.scheduler ? actualValues.filterOptions.scheduler.filter((filterRule: any) => filterRule?.key === 'keyword') : [];
    const dispatchFilterValues: any = {
      'grid': [...(jobFilterValue?.grid?.length ? jobFilterValue.grid : []), ...(gridSearchFilterRule?.length ? gridSearchFilterRule : [])],
      'employee': [...(jobFilterValue?.employee?.length ? jobFilterValue.employee : []), ...(employeeSearchFilterRule?.length ? employeeSearchFilterRule : [])],
      'scheduler': [...(jobFilterValue?.scheduler?.length ? jobFilterValue.scheduler : []), ...(schedulerSearchFilterRule?.length ? schedulerSearchFilterRule : [])],
      'map': filterValues.maps ? { ...this.getMapFilterValue(filterValues.maps) } : {}
    };
    
    if (this.dispatchCurrentTab === 'ROUTES') {
      dispatchFilterValues['grid_route'] = [...(jobFilterValue?.grid_route?.length ? jobFilterValue.grid_route : [])];
      dispatchFilterValues['scheduler_route'] = [...(jobFilterValue?.scheduler_route?.length ? jobFilterValue.scheduler_route : [])];
    }     
    return dispatchFilterValues;
  }

  getFilterValues(filterFormValues: any, actualValues: any): any {
    const defaultSortOptions: any = { grid: {}, employee: {}, scheduler: {}, map: {} };
    const filterOptions: any = this.getDispatchFilterValues(filterFormValues, actualValues);
    if (this.dispatchCurrentTab === 'ROUTES') {
      defaultSortOptions['grid_route'] = {};
    }
    return {
      filterOptions: filterOptions,
      sortOptions: actualValues?.sortOptions ?? defaultSortOptions,
      filterUid: actualValues?.filterUid ?? 'ALL',
      filterCount: this.getFilterCount(filterOptions, this.dispatchCurrentTab)
    };
  }

  getFilterCount(filterOptions: any, dispatchCurrentTab: 'JOBS' | 'ROUTES'): any {
    const defaultFilterOptions: any = this.defaultFilterOptions?.filterOptions;
    const filterCount: any = {
      'grid': this._dispatchBoardService.removeFilterRuleBySelector(this._dispatchBoardService.removeFilterKeyWithValue('keyword', '', this.advanceFilterService.getValidFilters(filterOptions?.grid)), {'key': 'territory_uid', 'source': 'dispatch_board_global'})?.length || 0,
      'employee':  this._dispatchBoardService.removeFilterKeyWithValue('keyword', '',  this.advanceFilterService.getValidFilters(filterOptions?.employee))?.length || 0,
      'scheduler':  this._dispatchBoardService.removeFilterKeyWithValue('keyword', '',  this.advanceFilterService.getValidFilters(filterOptions?.scheduler))?.length || 0,
      'map': this.getFilterValueCount(filterOptions?.['map'], defaultFilterOptions?.['map'])
    };
    if (dispatchCurrentTab === 'ROUTES') {
      filterCount['grid_route'] = this._dispatchBoardService.removeFilterKeyWithValue('keyword', '',  this.advanceFilterService.getValidFilters(filterOptions?.grid_route))?.length || 0;
      filterCount['scheduler_route'] = this._dispatchBoardService.removeFilterKeyWithValue('keyword', '',  this.advanceFilterService.getValidFilters(filterOptions?.scheduler_route))?.length || 0;
    }
    return filterCount;
  }

  getFilterValueCount(modifiedValues: any, defaultValues: any): number {
    if (!modifiedValues || !defaultValues) {
      return 0;
    }
    let count: number = 0;
    Object.keys(defaultValues).forEach((key: any) => {
      count += _.isEqual(defaultValues[key], modifiedValues[key]) ? 0 : 1;
    });
    return count;
  }

  constructFilterRules(rules: { key: string; value: any }[]): any {
    const filterRules: any[] = [];
    rules.forEach((rule): any => {
      switch (rule.key) {
        case 'work_order_number': {
          filterRules.push({
            'displayKeyValue': [
              rule.value
            ],
            'key': 'work_order_number',
            'operator': 'EQUAL_TO',
            'field_type': 'NUMBER',
            'value': Number(rule.value),
            'module': 'JOB',
            'type': 'default_field'
          });
          break;
        }
      }
    });
    return filterRules;
  }
}
